/* eslint-disable no-unused-vars */
import {
  Base64FileUploadField,
  Base64FileUploadFieldType,
} from './base64FileUploadField'

/**
 * Creates an instance of SignatureField.
 * @typedef {Object} SignatureFieldType
 *
 * @typedef {Base64FileUploadFieldType & SignatureFieldType} SignatureFieldExtendType
 */

/**
 * Represents a signature form field.
 * @class
 */
export class SignatureField extends Base64FileUploadField {}
